import request from '@/apis/axios'
import type { IResponse } from '@/apis/axios/config'
import type {
  delFolderParam,
  delFolderResult,
  delPassageParam,
  delPassageResult,
  folderListParam,
  folderListResult,
  movePassageParam,
  movePassageResult,
  newFolderParam,
  newFolderResult,
  uptPassageParam,
  uptPassageResult,
} from '~/apis/passageStorage/type'

/**
 * 1.2.5 지문 수정-완료
 */
export const ModifyPassage = (
  data: uptPassageParam,
): Promise<IResponse<uptPassageResult>> => {
  return request.put({ url: '/jadooApiV1/passageManage', data })
}

/**
 * 1.2.8 지문 삭제-완료
 */
export const DeletePassage = (
  data: delPassageParam,
): Promise<IResponse<delPassageResult>> => {
  return request.delete({ url: '/jadooApiV1/passageManage', data })
}

/**
 * 1.2.9 지문 폴더 이동-완료
 */
export const MovePassage = (
  data: movePassageParam,
): Promise<IResponse<movePassageResult>> => {
  return request.post({ url: '/jadooApiV1/movePassage', data })
}
/**
 * 1.2.10 폴더 리스트 조회
 */
export const FolderList = (
  params: folderListParam,
): Promise<IResponse<folderListResult>> => {
  return request.get({ url: '/jadooApiV1/folderManage', params })
}
/**
 * 1.2.11 폴더 생성-완료
 */
export const CreateFolder = (
  data: newFolderParam,
): Promise<IResponse<newFolderResult>> => {
  return request.post({ url: '/jadooApiV1/folderManage', data })
}
/**
 * 1.2.11 폴더 삭제-완료
 */
export const DeleteFolder = (
  data: delFolderParam,
): Promise<IResponse<delFolderResult>> => {
  return request.delete({ url: '/jadooApiV1/folderManage', data })
}
